import type { Item, Level, Scene, Wall } from '../core/hp/types';
import { legacyPivotBaseline } from './legacyPivotBaseline';

export const LEGACY_PIVOT_PROJECT = '6a9ebcec7ffb6ed5ed147d20';

/** Geometry only: a finish edit must not disable correction of an untouched import. */
export function legacyPivotFingerprint(item: Item, wall: Wall, level: Level): string {
  const point = (p: { x: number; z: number }) => [p.x, p.z];
  return JSON.stringify([
    item.id, item.modelRef.kind, item.modelRef.id, item.modelRef.raw, item.placement,
    point(item.position), item.elevation, item.rotation, [item.size.w, item.size.h, item.size.d],
    item.scale, item.mirrored, item.pivot, item.wallId,
    wall.id, point(wall.start), point(wall.end), point(wall.center), point(wall.dir), point(wall.normalIn),
    wall.length, wall.thickness, wall.height, wall.forward, level.height,
  ]);
}

/** One known import repair; never infer corrections from a user's current placement. */
export function repairLegacyPivots(scene: Scene, projectId: string): Scene {
  if (projectId !== LEGACY_PIVOT_PROJECT || scene.projectId !== projectId || scene.legacyPivotRepair === 1
    || !Array.isArray(scene.levels)) return scene;
  const next = structuredClone(scene);
  for (const record of legacyPivotBaseline) {
    const level = next.levels[record.level];
    const item = level?.items?.find(item => item.id === record.id);
    const wall = item && level.walls?.find(wall => wall.id === item.wallId);
    if (!item || !wall || item.modules?.length || legacyPivotFingerprint(item, wall, level) !== record.fingerprint) continue;
    item.elevation = record.elevation;
    item.pivot = record.pivot;
  }
  // Record even skipped placements, so a later deliberate edit back to that exact
  // transform cannot be mistaken for an untouched import on another reload.
  next.legacyPivotRepair = 1;
  return next;
}
